<template>
  <div class="modal-backdrop">
    <div class="card col-lg-4 col-md-8 col-11 p-0 marginper15 mx-auto">
      <div class="modal-content border-0">
        <div class="modal-header delete-modal pb-0">
          <h5 class="modal-title fontsize20 black80 proximanova" id="deleteLikeVideoModalLabel">{{modalTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelConfirmmodal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body backgroundcolorwhite modal-delete text-center">
          <span class="button-cancel-font modaldeletebtn mouseoverbtn1 borderradius20 pointer border p-2 pr-4 pl-4 proximanova" @click="cancelConfirmmodal" data-dismiss="modal" aria-label="Close" >No</span>
          <button class="button-cancel-font backgroundcolorblack mouseoverbtn2 borderradius20 pointer white border p-1 ml-2 pr-4 pl-4 proximanova" @click="conirmBtnClicked()">Yes</button>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
export default{
   data() {
    return{
    }
  },
  props : [
    'modalTitle'
  ],
  methods:{
    
    close(type) {
        this.$emit('closeConfirmModal', type);
    },
    cancelConfirmmodal() {
        this.close('NOTSUCCESS')
    },
    conirmBtnClicked() {
        this.close('SUCCESS')
    }
  },
   mounted() {
  },

}

</script>

<style>
@import '../css/modal.css';
</style>